<div *ngIf="data" class="asset-view">
  <div class="asset-container">
    <!-- Disabling pointer events on expired images, to hide the 'save as image' menu on right click -->
    <div *ngIf="data.previewUrl && data.assetType === AssetTypes.Image" class="asset-wrapper">
      <thehubz-asset-image class="makeos-asset w-full" [style.pointerEvents]="data && !(data.expiryDate | dateNotExpired) ? 'none' : 'all'" [asset]="data"></thehubz-asset-image>
      <div *ngIf="data.expiryDate | dateNotExpired" class="media-asset-toolbar">
        <ul class="media-asset-toolbar-list media-asset-toolbar-area">
          <li class="media-asset-toolbar-item">
            <button class="media-asset-toolbar-action zoom-action" i18n-matTooltip matTooltip="Expand asset" (click)="this.assetFullScreen.openAsset(data)">
              <mat-icon>open_in_full</mat-icon>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <div *ngIf="data.previewUrl && data.assetType === AssetTypes.PowerpointPresentation" class="asset-wrapper">
      <thehubz-asset-power-point [asset]="data" class="makeos-asset w-full"></thehubz-asset-power-point>
      <div *ngIf="data.expiryDate | dateNotExpired" class="media-asset-toolbar">
        <ul class="media-asset-toolbar-list media-asset-toolbar-area">
          <li class="media-asset-toolbar-item">
            <button class="media-asset-toolbar-action zoom-action" i18n-matTooltip matTooltip="Expand asset" (click)="this.assetFullScreen.openAsset(data)">
              <mat-icon>open_in_full</mat-icon>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <div *ngIf="data.assetType === AssetTypes.Pdf" class="asset-wrapper">
      <thehubz-asset-pdf [asset]="data" class="makeos-asset w-full"></thehubz-asset-pdf>
      <div *ngIf="data.expiryDate | dateNotExpired" class="media-asset-toolbar">
        <ul class="media-asset-toolbar-list media-asset-toolbar-area">
          <li class="media-asset-toolbar-item">
            <button class="media-asset-toolbar-action zoom-action" i18n-matTooltip matTooltip="Expand asset" (click)="this.assetFullScreen.openAsset(data)">
              <mat-icon>open_in_full</mat-icon>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <div *ngIf="data.previewUrl && data.assetType === AssetTypes.HtmlBanner" class="asset-wrapper">
      <thehubz-asset-html-banner [asset]="data" class="makeos-asset w-full" [toolbar]="true"></thehubz-asset-html-banner>
      <div *ngIf="data.expiryDate | dateNotExpired" class="media-asset-toolbar">
        <ul class="media-asset-toolbar-list media-asset-toolbar-area">
          <li class="media-asset-toolbar-item">
            <button class="media-asset-toolbar-action zoom-action" mat-icon-button i18n-matTooltip matTooltip="Expand asset" (click)="this.assetFullScreen.openAsset(data)">
              <mat-icon>open_in_full</mat-icon>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <div *ngIf="data.previewUrl && data.assetType === AssetTypes.Video" class="asset-wrapper">
      <thehubz-asset-video [asset]="data" class="makeos-asset w-full"></thehubz-asset-video>
      <div *ngIf="data.expiryDate | dateNotExpired" class="media-asset-toolbar">
        <ul class="media-asset-toolbar-list media-asset-toolbar-area">
          <li class="media-asset-toolbar-item">
            <button class="media-asset-toolbar-action zoom-action" i18n-matTooltip matTooltip="Expand asset" (click)="this.assetFullScreen.openAsset(data)">
              <mat-icon>open_in_full</mat-icon>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <div *ngIf="data.previewUrl && data.assetType === AssetTypes.Audio" class="asset-wrapper">
      <thehubz-asset-audio [asset]="data" class="makeos-asset w-full h-full"></thehubz-asset-audio>
    </div>

    <div *ngIf="!data.previewUrl && (data.expiryDate | dateNotExpired)" class="asset-wrapper h-full flex min-h-[40vh] justify-center items-center">
      <span class="text-xl font-bold" i18n>Preview Not Available</span>
    </div>

    <sp-overlay
      class="asset-overlay-semitransparent"
      [class]="data.assetType === AssetTypes.Video ? 'h-16 self-center' : ''"
      *ngIf="data && brandingKey !== CustomClients.Standard && (!(data.expiryDate | dateNotExpired) || data.status === Status.Archived || data.status === Status.Draft)"
    >
      <span class="text-4xl font-bold" i18n *ngIf="!(data.expiryDate | dateNotExpired)">Expired</span>
      <span class="text-4xl font-bold" i18n *ngIf="(data.expiryDate | dateNotExpired) && data.status === Status.Archived">Archived</span>
      <span class="text-4xl font-bold" i18n *ngIf="(data.expiryDate | dateNotExpired) && data.status === Status.Draft">Draft</span>
    </sp-overlay>
  </div>

  <!-- Control buttons -->
  <!-- Keeping the below control buttons at the end, so that they always appear on top and are clickable -->

  <nav *ngIf="storedAssetsIds.length > 1" class="asset-navigator">
    <button class="cursor-pointer icons backward" i18n-matTooltip matTooltip="Previous asset" (click)="changeAsset(false)">
      <mat-icon class="scale-150">navigate_before</mat-icon>
    </button>

    <button class="cursor-pointer icons forward" i18n-matTooltip matTooltip="Next asset" (click)="changeAsset(true)">
      <mat-icon class="forward scale-150">navigate_next</mat-icon>
    </button>
  </nav>

  <!-- !END Control buttons -->
</div>
